var modal = require('./modal-static')
require('./modal-link')
require('./modal-dynamic')
require('./modal-photos')
require('./modal-mini')
require('./modal-mail')
require('./modal-virtual-gifts')
require('./modal-switch-off')

module.exports = {set:modal.set, destroy:modal.destroy};